import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-widget-multi-question-v0-text',
  styles: [`
    .ellipsis-multiline {
      /*width: 200px;*/
      width:100%;
      min-height: 50px;
      max-height: 200px;
      background: white;
      padding: 0 10px;
      overflow: hidden;
      border: 1px solid #33333333;
      display: -webkit-box;
      -webkit-line-clamp: 5; /* Numero massimo di righe */
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .popover-with-scrollbar {
      width: 200px;
      height: 200px;
      overflow-y: auto;
    }
  `],
  template: `
    <ng-template #popContent let-greeting="greeting">
      <div class="popover-with-scrollbar">
        {{ value || noResponseLabel }}
      </div>
    </ng-template>
    <div class="ellipsis-multiline"
         *ngIf="readonly"
         [ngbPopover]="popContent"
         [autoClose]="true">
      {{ value || noResponseLabel }}
    </div>
  `,
})
export class WidgetMultiQuestionV0TextComponent {
  @Input() noResponseLabel: string;
  @Input() value?: string;
  @Input() readonly = true;
  public currentValue: string;
}
